export const config = {
    // DO NOT USE THESE CREDENTIALS ! THEY ARE HERE TO HELP IN THE LEARNING PROCESS.
    // ANY AND ALL DATA ON THAT DOMAIN IS SUBJECT TO CHANGE AND REMOVAL AT ANY TIME
    // THIS ACCOUNT IS ALSO ON THE FREE PLAN AND IS SUBJECT TO RESTRICTIONS !
    apiKey: "AIzaSyD4zbq694Fd853NIor2kJXvIgG5WLp_Q8k",
    authDomain: "mgi-interactive-map.firebaseapp.com",
    projectId: "mgi-interactive-map",
    storageBucket: "mgi-interactive-map.appspot.com",
    messagingSenderId: "238668892095",
    appId: "1:238668892095:web:97fab597c117befb7e830a"
  };
  